import { t } from 'i18next';
import { reportStateEnum } from '../report';

export const reportStateLabels: Record<number, string> = {
    [reportStateEnum.VALIDATED]: 'validation',
    [reportStateEnum.REPORTFILLED]: 'submitted',
    [reportStateEnum.REPORT]: 'report',
    [reportStateEnum.PLANNING]: 'planning',
    [reportStateEnum.NEEDS]: 'need',
};

export const getReportStateLabel = (state?: number): string => {
    return state !== undefined && reportStateLabels[state] ? t(reportStateLabels[state]) : '';
};
